import React from 'react';
import { Moment } from 'moment';
import { DailyPatientUsageSummaryDto } from '@peartherapeutics/hylia-api-client';
import CustomCalendar from './CustomCalendar';
import styles from './styles.module.scss';

interface ICalendarProps {
  dailySummaries: DailyPatientUsageSummaryDto[];
  updateMedicationCompliances: (calendarMonth: Moment) => void;
  showBup: boolean;
}

const SubstanceUseCalendar = (props: ICalendarProps) => {
  const { dailySummaries, updateMedicationCompliances, showBup } = props;

  return (
    <div className={styles.wrapper} data-testid="substance-use">
      <CustomCalendar
        updateMedicationCompliances={updateMedicationCompliances}
        dailySummaries={dailySummaries}
        showBup={showBup}
      />
    </div>
  );
};

export default SubstanceUseCalendar;
